import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { RouterModule } from "@angular/router";
import { CarouselModule } from "@shared/components/carousel/carousel.module";
import { CommonTranslateModule } from "@shared/utils/common-translate.module";
import { LandingPageComponent } from "./landing-page.component";

const materialModules = [MatProgressSpinnerModule, MatIconModule];

@NgModule({
  declarations: [LandingPageComponent],
  providers: [],
  imports: [CommonModule, CommonTranslateModule, RouterModule, CarouselModule, ...materialModules],
})
export class LandingPageModule {}
